export const trackingTranslations = {
  en: {
    tracking: {
      title: 'Track Your Shipment',
      subtitle: 'Monitor your shipment status in real-time',
      placeholder: 'Enter Container / Booking or Bill of Lading Number',
      button: 'Track Now',
      loading: 'Searching...',
      not_found: 'Shipment not found. Please verify the number.',
      error: 'An error occurred. Please try again.',
      shipment_details: 'Shipment Details',
      shipment_number: 'Shipment Number',
      container_number: 'Container Number',
      booking_number: 'Booking Number',
      origin: 'Port of Origin',
      destination: 'Port of Destination',
      carrier: 'Shipping Line',
      weight: 'Weight',
      volume: 'Volume (CBM)',
      est_departure: 'Estimated Departure Date',
      est_arrival: 'Estimated Arrival Date',
      status: 'Current Status',
      history: 'Tracking History',
      statuses: {
        pending: 'Pending / Cargo Received at Warehouse',
        loaded: 'Loaded into Container',
        at_sea: 'In Transit / At Sea',
        at_port: 'Arrived at Destination Port',
        customs: 'Under Customs Clearance',
        released: 'Customs Cleared & Released',
        delivered: 'Delivered to Customer',
        delayed: 'Delayed'
      }
    }
  },
  ar: {
    tracking: {
      title: 'تتبع شحنتك',
      subtitle: 'راقب حالة شحنتك في الوقت الفعلي',
      placeholder: 'أدخل رقم الحاوية، رقم الحجز أو بوليصة الشحن',
      button: 'تتبع الآن',
      loading: 'جاري البحث...',
      not_found: 'لم يتم العثور على الشحنة. يرجى التحقق من الرقم المدخل.',
      error: 'حدث خطأ. يرجى المحاولة مرة أخرى.',
      shipment_details: 'تفاصيل الشحنة',
      shipment_number: 'رقم الشحنة',
      container_number: 'رقم الحاوية',
      booking_number: 'رقم الحجز',
      origin: 'ميناء الإقلاع',
      destination: 'ميناء الوصول',
      carrier: 'الخط الملاحي',
      weight: 'الوزن الإجمالي',
      volume: 'الحجم (متر مكعب)',
      est_departure: 'تاريخ الإقلاع المتوقع',
      est_arrival: 'تاريخ الوصول المتوقع',
      status: 'الحالة الحالية',
      history: 'سجل حركة الشحنة',
      statuses: {
        pending: 'قيد الانتظار / تم استلام البضاعة في المستودع',
        loaded: 'تم تحميل البضاعة في الحاوية',
        at_sea: 'في البحر / قيد العبور',
        at_port: 'وصلت إلى ميناء الوصول',
        customs: 'قيد التخليص الجمركي',
        released: 'تم التخليص الجمركي والإفراج عنها',
        delivered: 'تم التسليم للعميل',
        delayed: 'متأخرة'
      }
    }
  },
  tr: {
    tracking: {
      title: 'Gönderinizi Takip Edin',
      subtitle: 'Gönderinizin durumunu gerçek zamanlı olarak takip edin',
      placeholder: 'Konteyner, Rezervasyon veya Konşimento Numarasını Girin',
      button: 'Sorgula',
      loading: 'Aranıyor...',
      not_found: 'Gönderi bulunamadı. Lütfen numarayı kontrol edin.',
      error: 'Bir hata oluştu. Lütfen tekrar deneyin.',
      shipment_details: 'Gönderi Detayları',
      shipment_number: 'Gönderi Numarası',
      container_number: 'Konteyner Numarası',
      booking_number: 'Rezervasyon Numarası',
      origin: 'Yükleme Limanı',
      destination: 'Varış Limanı',
      carrier: 'Nakliye Hattı (Armatör)',
      weight: 'Brüt Ağırlık',
      volume: 'Hacim (CBM)',
      est_departure: 'Tahmini Kalkış Tarihi',
      est_arrival: 'Tahmini Varış Tarihi',
      status: 'Güncel Durum',
      history: 'Gönderi Geçmişi',
      statuses: {
        pending: 'Beklemede / Yük Depoya Teslim Edildi',
        loaded: 'Konteynere Yüklendi',
        at_sea: 'Transit Halinde / Denizde',
        at_port: 'Varış Limanına Ulaştı',
        customs: 'Gümrük İşlemlerinde',
        released: 'Gümrükten Çekildi / Serbest Bırakıldı',
        delivered: 'Alıcıya Teslim Edildi',
        delayed: 'Gecikmeli'
      }
    }
  }
};

export const statusOrder = [
  'pending',
  'loaded',
  'at_sea',
  'at_port',
  'customs',
  'released',
  'delivered'
];
